<div
  class="d-flex justify-content-between align-items-center globalborder-btm-header pb-3 pt-2 px-3">
  <h2 class="mb-0">Total AP - Misc</h2>
  <div
    class="d-flex justify-content-between align-items-center globalborder-btm-header pb-3 pt-2">
    <div class="lds-ring inline me-auto ms-2" *ngIf="false">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <div class="user-panel col-auto d-flex justify-content-between">
    <div class="d-flex align-items-center gap-3">
      <p-button
        label="Export Excel"
        variant="outlined"
        icon="pi pi-cloud-upload"
        severity="secondary"
        (click)="exportExcelFile()"
        class="fullwdth secondary-btn" />

      <p-button label="Clear Filters" (click)="clearTable(dt)" />

      <span class="cross-border" (click)="onCloseModalEvent()"
        ><i class="pi pi-times"></i
      ></span>
    </div>
  </div>
</div>

<div class="p-wrapper-custom">
  <p-table
    #dt
    stripedRows
    [scrollable]="true"
    scrollHeight="calc(100vh - 265px)"
    [size]="'small'"
    [resizableColumns]="true"
    [rows]="20"
    responsiveLayout="scroll"
    [value]="totalApMiscList"
    [rowHover]="true"
    [rows]="20"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 20, 50, 1000]"
    [paginator]="totalApMiscList.length >= 20"
    [autoLayout]="true"
    [resizableColumns]="true"
    styleClass="table-listing p-head-pad p-datatable-customers">
    <ng-template pTemplate="caption">
      <div class="d-flex align-items-center">
        <ng-container *ngIf="totalApMiscList?.length">
          <div
            class="form-group has-float-label me-2 px-2 d-flex align-items-center gap-2">
            <label class="form-label" for="total">Total</label>
            <input
              pInputText
              jniAutoCompleteBlocker
              class="form-control filter me-2 text-end"
              type="text"
              [value]="total | number: '1.2-2'"
              disabled />
          </div>
        </ng-container>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="Date">
          Date <p-sortIcon field="Date"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="Date"
            display="menu"></p-columnFilter>
        </th>
        <th pSortableColumn="ProjectName">
          Project name <p-sortIcon field="ProjectName"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="ProjectName"
            display="menu"></p-columnFilter>
        </th>
        <th pSortableColumn="CategoryID">
          Category ID <p-sortIcon field="CategoryID"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="CategoryID"
            display="menu"></p-columnFilter>
        </th>
        <th pSortableColumn="Description">
          Description <p-sortIcon field="Description"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="Description"
            display="menu"></p-columnFilter>
        </th>
        <th pSortableColumn="AmountinTransactionCurrency">
          Amount In Transaction Currency
          <p-sortIcon field="AmountinTransactionCurrency"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="AmountinTransactionCurrency"
            display="menu"></p-columnFilter>
        </th>
        <th pSortableColumn="OriginReferenceID">
          Origin reference <p-sortIcon field="OriginReferenceID"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="OriginReferenceID"
            display="menu"></p-columnFilter>
        </th>

        <th pSortableColumn="VendInvoiceID">
          Invoice <p-sortIcon field="VendInvoiceID"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="VendInvoiceID"
            display="menu"></p-columnFilter>
        </th>

        <th pSortableColumn="TrackingNumber">
          Tracking number <p-sortIcon field="TrackingNumber"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="TrackingNumber"
            display="menu"></p-columnFilter>
        </th>
        <th pSortableColumn="CreatedDateTime">
          Created Date and Time
          <p-sortIcon field="CreatedDateTime"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="CreatedDateTime"
            display="menu"></p-columnFilter>
        </th>
        <th pSortableColumn="CreatedBy">
          Created By <p-sortIcon field="CreatedBy"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="CreatedBy"
            display="menu"></p-columnFilter>
        </th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-commissionPaidTotal
      let-rowIndex="rowIndex">
      <tr
        class="p-selectable-row"
        [pSelectableRow]="commissionPaidTotal"
        [pSelectableRowIndex]="rowIndex">
        <td>{{ commissionPaidTotal.Date | date: "yyyy-MM-dd" }}</td>
        <td>{{ commissionPaidTotal.ProjectName }}</td>
        <td>{{ commissionPaidTotal.CategoryID }}</td>
        <td>{{ commissionPaidTotal.Description }}</td>
        <td class="align-right">
          {{
            commissionPaidTotal.AmountinTransactionCurrency | number: "1.2-2"
          }}
        </td>
        <td>{{ commissionPaidTotal.OriginReferenceID }}</td>
        <td>{{ commissionPaidTotal.VendInvoiceID }}</td>
        <td class="name">
          <a
            class="link"
            (click)="
              onTrackingNumberSelection(commissionPaidTotal.TrackingNumber)
            ">
            {{ commissionPaidTotal.TrackingNumber }}
          </a>
        </td>
        <td>
          <span *ngIf="commissionPaidTotal?.CreatedDateTime | hidedynamicsdate">
            {{ commissionPaidTotal.CreatedDateTime | date: "yyyy-MM-dd" }}
          </span>
        </td>
        <td>{{ commissionPaidTotal.CreatedBy }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="20">No Data Found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<jni-modal-stacker
  *ngIf="orderTrackingDisplayModal"
  [displayModal]="orderTrackingDisplayModal"
  (closeEvent)="closeModalFromOrderTracking()">
  <h1 class="panelHeading">Freight Details</h1>
  <div class="panelBody">
    <jni-freight-details
      [isModal]="true"
      [trackingNumber]="trackingNumber"
      (closeEvent)="closeModalFromOrderTracking()"></jni-freight-details>
  </div>
</jni-modal-stacker>
